import Link from 'next/link';
import { V2RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './emptyHistory.module.scss';

const cx = classnames.bind(styles);

const EmptyHistory = () => {
  const url = `${V2RouteUrl.PHS_PST_TEST_GATE}?open=tutorial`;

  return (
    <div className={cx('emptyArea')}>
      <em className={cx('emphasis')}>제출 이력이 존재하지 않습니다.</em>
      <span className={cx('desc')}>문제가 어려우셨다면 튜토리얼을 통해 연습해보세요.</span>
      <Link href={url} legacyBehavior>
        <a className={cx('btn')} role="button" target="_blank">
          튜토리얼 바로가기
        </a>
      </Link>
    </div>
  );
};

export default EmptyHistory;
